import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { obtenerPeriodos } from '../../../../redux/DucksUnidadInspeccion/PeriodosDuck';
import { actualizarPeriodo } from '../../../../redux/DucksUnidadInspeccion/PeriodosDuck';
import { Edit } from '@mui/icons-material';

import { actualizarFolio, obtenerFolios } from '../../../../redux/DucksUnidadInspeccion/FoliosUIDuck';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { ErrorMessage, Field, Form, Formik } from 'formik';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    height: '60%',
};

function ConfiguracionFoliosUIComponent(props) {

    const dispatch = useDispatch();

    const [folios, setFolios] = React.useState([])

    const [openActualizar, setOpenActualizar] = React.useState(false)
    const [folioSeleccionado, setFolioSeleccionado] = React.useState(false)


    React.useEffect(() => {
        dispatch(obtenerFolios()).then((res) => {
            setFolios(res.payload.data.data)
        })
    }, [])

    const handleOpenActualizar = (f) => {
        console.log(f)
        setFolioSeleccionado(f)
        setOpenActualizar(true)
    }

    const handleCloseActualizar = () => {
        setOpenActualizar(false)
    }

    const modalActualizarFolio = () => {
        return (
            <Modal
                open={openActualizar}
                onClose={handleCloseActualizar}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Formik
                        initialValues={{
                            idfolio: folioSeleccionado.idfolio,
                            folio: folioSeleccionado.folio,
                            descripcion: folioSeleccionado.descripcion
                        }}
                        enableReinitialize={true}
                        validate={values => {
                            const errors = {};

                            if (!values.folio) {
                                errors.folio = 'Campo requerido';
                            }

                            if (!values.descripcion) {
                                errors.descripcion = 'Campo requerido';
                            }

                            return errors;
                        }}
                        onSubmit={(values) => {

                            let data = {
                                data: {
                                    idfolio: values.idfolio,
                                    folio: values.folio,
                                    descripcion: values.descripcion
                                }
                            }
                            console.log(data)
                            dispatch(actualizarFolio(data)).then((res) => {
                                dispatch(obtenerFolios()).then((res) => {
                                    setFolios(res.payload.data.data)
                                    handleCloseActualizar()
                                })
                            })
                        }}
                    >

                        {({ values, isSubmitting }) => (
                            <Form>
                                <div style={{ textAlign: "center" }}>
                                    <h5>Editar Folio</h5>
                                    <h6>(Configuracion Global)</h6>
                                    <hr />
                                    <br />
                                    <div className="form-group row">
                                        <label htmlFor="folio" class="col-sm-4 col-form-label">Folio</label>
                                        <div className="col-sm-6">
                                            <Field
                                                type="number" className="form-control form-control-sm"
                                                name="folio"
                                            />
                                            <ErrorMessage style={{ color: 'red' }} name="folio" component="div" /><br />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="descripcion" className="col-sm-4 col-form-label">Descripcion</label>
                                        <div class="col-sm-6">
                                            <Field
                                                type="text" className="form-control form-control-sm"
                                                name="descripcion"
                                            />
                                            <ErrorMessage style={{ color: 'red' }} name="descripcion" component="div" /><br />
                                        </div>
                                    </div>
                                    <button type='submit' className='btn btn-success'>Aceptar</button>
                                </div>
                            </Form>
                        )}

                    </Formik>
                </Box>
            </Modal>
        )
    }


    return (
        <Fragment><br />
            <h4>Folios</h4>
            <h5>Seleccione un Folio:</h5>
            <div className="table-responsive">
                <table className='table table-hover'>
                    <thead>
                        <tr>
                            <th>Folio</th>
                            <th>Descripcion</th>
                        </tr>
                    </thead>
                    <tbody >
                        {
                            folios.map((f, index) => {
                                return (
                                    <tr key={index} >
                                        <td style={{ textAlign: 'center' }}>{f.folio}</td>
                                        <td style={{ textAlign: 'center' }}>{f.descripcion}</td>
                                        <td><button className='btn btn-success btn-sm' onClick={() => { handleOpenActualizar(f) }}><Edit></Edit></button></td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
            {modalActualizarFolio()}
        </Fragment>
    );
};


export default withRouter(ConfiguracionFoliosUIComponent)
